<template>
  <div class="my-index">
    <el-container>
      <el-aside width="200px">
        <el-row class="tac">
          <el-menu
            class="el-menu-vertical-demo"
            router
            :default-active="$route.path"
            :default-openeds="open"
            :unique-opened="true"
            @open="handleOpen"
          >
            <el-submenu
              v-for="(item, index) in side_config"
              :index="`${index + 1}`"
              :key="index"
            >
              <template slot="title">
                <i :class="item.icon"></i>
                <span>{{ item.cn_name }}</span>
              </template>

              <el-menu-item
                v-for="(v, i) in item.children"
                :key="`${index + 1 - (i + 1)}`"
                :index="v.path"
                @click="goSomepage(v)"
                :class="$route.path.indexOf(v.path) != -1 ? 'is-active' : ''"
              >
                <div class="flex-item">
                  <tips
                    :name="v.name"
                    v-if="v.cn_name == '商家交易管理'"
                  ></tips>
                  <div>{{ v.cn_name }}</div>
                </div>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-row>
      </el-aside>
      <el-main>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            v-for="(item, index) in breadcrumb"
            :key="item.index"
            ><span class='menu-pointer' @click="delSomepage(index, item)">{{ item.cn_name }}</span></el-breadcrumb-item
          >
        </el-breadcrumb>
        <div class='content'>
          <router-view />
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<style scoped>
.title {
  line-height: 100px;
}
.flex-item {
  position: relative;
  display: flex;
  flex-direction: row-reverse;
}
.my-index {
  width: 1340px;
  margin: 0 auto;
}
.menu-pointer{
  cursor: pointer;
}
.menu-pointer:hover{
  color:#6435E8;
}
</style>

<script>
import side_config from "../../config/side";
import tips from "./tips.vue";
export default {
  name: "index",
  data() {
    return {
      open: ["1"],
      side_config: [],
      breadcrumb: [],
    };
  },
  components: {
    tips: tips,
  },
  created() {
    this.setMune();
  },
  watch: {
    // 对路由变化作出响应...
    $route: {
      handler: function() {
        this.getRout();
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    goSomepage(data) {
      let _this = this;
      let path = data.path;
      if (path === this.$route.path) {
        this.$router.push({
          path: path,
          query: {},
        });
        this.$router.go(0);
      }
    },
    handleSelect(path) {

    },
    setMune() {
      //'账号类型 1淘客 2内部招商 3短视频机构 4自媒体机构 5渠道 6电商独立店铺',
      let myinfo = side_config.myinfo;
      this.side_config = this.setSide(myinfo, this.$http.cookie.get("user_info").type);
    },
    setSide(list, types) {
      let _this = this;
      let arr = [];
      let obj = {};
      list.forEach((item) => {
        if (item.type.includes(types)) {
          if (item.children) {
            item.children = _this.setSide(item.children, types);
            obj = {
              cn_name: item.cn_name,
              name: item.name,
              path: item.path,
              icon: item.icon ? item.icon : "",
              name: item.name,
              children: item.children ? item.children : [],
              type: item.type,
            };
          } else {
            obj = {
              cn_name: item.cn_name,
              name: item.name,
              path: item.path,
              icon: item.icon ? item.icon : "",
              name: item.name,
              children: item.children ? item.children : [],
              type: item.type,
            };
          }
          arr.push(obj);
        }
      });
      return arr;
    },
    handleOpen(key, keyPath) {
      this.open = keyPath;
    },
    getRout() {
      let _this = this;
      this.breadcrumb = [];
      let path = this.$route.path;
      // return
      let a = path.split("/")[1] || "";
      let b = path.split("/")[2] || "";
      let c = path.split("/")[3] || "";
      let d = path.split("/")[4] || "";
      this.v = this.$http.getAuth("auth_token") ? null : "login";
      // debugger
      side_config.myinfo.forEach((item, index) => {
        // 登陆注册清除缓存
        if (a == "login") {
          this.$http.removeAuth();
        }
        if (a == item.name) {
          this.breadcrumb.push({
            cn_name: item.cn_name,
          });
          // 2级
          item.children.forEach((v, i) => {
            if (b == v.name) {
              this.breadcrumb.push({
                cn_name: v.cn_name,
                name:v.name,
                path:v.path
              });
            }
            if (v.children) {
              v.children.forEach((m, n) => {
                if (c == m.name) {
                  this.breadcrumb.push({
                    cn_name: m.cn_name,
                    name: m.name,
                    path: m.path
                  });
                }
                if (m.children) {
                  m.children.forEach((j, k) => {
                    if (d == j.name) {
                      this.breadcrumb.push({
                        cn_name: j.cn_name,
                      });
                    }
                  })
                }
              });
            }
          });
        }
      });
    },
    delSomepage(index, item){
      let path = this.$route.path;
      if(path==item.path){
        return false;
      }
      if(item.name && index == 1){
        this.$router.push({
          name:item.name,
          query:{
            v:'0'
          }
        })
      } else if (index == 2) {
        window.history.go(-1)
      }
    }
  },
};
</script>
